module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/weather/night-fog-8bf14eec7bf5679fa99ad4ac25b0aa26.svg";